require('./ctxPivotTagFilter.style.scss');

const template = require('./ctxPivotTagFilter.template.html');

class PivotTagFilterController {
    constructor($scope, $filter, utilsService, config) {
        this.uniqueValues = [];
        this.filterValues = [];
        this.$scope = $scope;
        this.$filter = $filter;
        this.utilsService = utilsService;
        this.configGeneral = config;
    }

    formatTableValue(value, property) {
        let result = '';
        let tag = this.tags.filter(tag => tag.key === property)[0]
        let attributeType = tag.type ? tag.type : tag;
        const locale = window.navigator.userLanguage || window.navigator.language || 'en';
        switch (attributeType) {
            case 'size': {
                if (isNaN(value) || value === null || value < 0) {
                    result += 'N/A'; //initialized as N/A because the tag is used in aggregations
                } else {
                    let temp = this.utilsService.fromBytes(value);
                    let unit = !temp.unit ? '' : (temp.unit === 'byte' ? 'B' : temp.unit.charAt(0).toUpperCase() + temp.unit.slice(1, 2) + temp.unit.charAt(2).toUpperCase());
                    result += temp.value + ' ' + unit;
                }
            }
                break;
            case 'datetime': {
                if (value === "null") {
                    result += 'N/A';
                } else {
                    const dateFormat = this.configGeneral.dateFormats['shortSec'];
                    let temp = moment(value).locale(locale).format(dateFormat['datetime']);
                    result += temp === 0 ? '' : temp;
                }
            }
                break;
            case 'time_day': {
                if (value === "null") {
                    result += 'N/A';
                } else {
                    const dateFormat = this.configGeneral.dateFormats['short'];
                    let temp = moment(value).locale(locale).format(dateFormat['date']);
                    result += temp === 0 ? '' : temp;
                }
            }
                break;

            case 'time_hour': {
                if (value === "null") {
                    result += 'N/A';
                } else {
                    result += value === null || value === undefined ? '' : value + 'H';
                }
            }
                break;
            case 'duration': {
                if (value === "null") {
                    result += 'N/A';
                } else {
                    let temp;
                    if ($.isNumeric(value)) {
                        temp = new Date(value * 1000).toISOString().substr(11, 8);
                    }
                    result += temp === 0 ? '' : temp;
                }
            }
                break;
            case 'percentage': {
                if (value === "null") {
                    result += 'N/A';
                } else {
                    if ($.isNumeric(value)) {
                        result += (value * 100).toFixed(0) + "%";
                    } else {
                        result += value || '';
                    }
                }
            }
                break;
            default: result += (value === "null" || value === "") ? "N/A" : value; break;
        }
        result += ' ';
        return result === '' ? value : result;
    }

    $onInit() {
        //set dropdown opening position
        $(".pvtFilterBox").css({ "left": this.tagPosition.left - 27 + 'px', "top": this.tagPosition.top + 20 + 'px' });

        this.tag = this.tags.find(o => o.key === this.editTag.key);

        //support for older report versions that had labels instead of keys in config
        if (this.config.exclusions) {
            this.config.exclusions = this.renameKeys(this.config.exclusions, false);
        }
        if (this.config.inclusions) {
            this.config.inclusions = this.renameKeys(this.config.inclusions, false);
        }
        //get unique values from selected tag
        var uniqueValuesTree = [];
        uniqueValuesTree = Array(_.map(this.data, this.tag.key))[0].reduce((acc, o) => (acc[o] = (acc[o] || 0) + 1, acc), {});

        //add missing predefined values if they are defined
        if (this.tag.predefined_values) {
            this.tag.predefined_values.forEach(value => {
                if (!uniqueValuesTree.hasOwnProperty(value)) {
                    uniqueValuesTree[value] = 0;
                }
            })
        }

        var sortedUniqueValues = {};
        Object.keys(uniqueValuesTree).sort().forEach(function (key) {
            sortedUniqueValues[key] = uniqueValuesTree[key];
        });
        //create array of tag values and selected state objects from unique values

        for (const [key, value] of Object.entries(sortedUniqueValues)) {
            this.filterValues.push({
                name: this.formatTableValue(key, this.tag.key),
                value: key,
                selected: this.isExcluded(key),
                count: value
            })
        }
    }

    // set tag value checked state based on if value is excluded from filtering
    isExcluded(value) {

        if (this.filteringMode === 'include' && this.config.inclusions && this.config.inclusions[this.tag.key]) {
            if (this.config.inclusions[this.tag.key].indexOf(value) !== -1) {
                return true;
            } else {
                return false;
            }
        } else if (this.filteringMode === 'exclude' && this.config.exclusions && this.config.exclusions[this.tag.key])
            if (this.config.exclusions[this.tag.key].indexOf(value) !== -1) {
                return false;
            } else {
                return true;
            }
        else {
            return true;
        }
    }

    renameKeys(obj, isExclusion) {
        const keyValues = Object.keys(obj).map(key => {
            if (key[0] === key[0].toUpperCase()) {
                const newKey = this.toServerCase(key) || key;
                isExclusion ? delete this.config.exclusions[key] : delete this.config.inclusions[key]
                return { [newKey]: obj[key] };
            } else {
                return { [key]: obj[key] }
            }
        });
        return Object.assign({}, ...keyValues);
    }

    // on apply tag filter config manipulation
    onApplyFilter() {
        if (this.getSelectedCount() !== this.filterValues.length) {
            // if atleast one checked create/modify exclusion property with tag name and array of excluded values
            if (!this.config.exclusions) {
                this.config.exclusions = {
                    [this.tag.key]: this.filterValues.filter((value) => value.selected === false).map(value => value.value)
                }
            } else {
                this.config.exclusions[this.tag.key] = this.filterValues.filter((value) => value.selected === false).map(value => value.value)
            }
            // add included values property
            if (!this.config.inclusions) {
                this.config.inclusions = {
                    [this.tag.key]: this.filterValues.filter((value) => value.selected === true).map(value => value.value)
                }
            } else {
                this.config.inclusions[this.tag.key] = this.filterValues.filter((value) => value.selected === true).map(value => value.value)
            }
        } else {
            // if none checked delete selected tag name property
            if (this.config.exclusions && this.config.exclusions[this.tag.key]) {
                delete this.config.exclusions[this.tag.key]
            }
            if (this.config.inclusions && this.config.inclusions[this.tag.key]) {
                delete this.config.inclusions[this.tag.key]
            }
        }

        // run ctxPivotTable.component.js onFilter function with newly created config for report rendering
        this.onFilter(this.config)
        this.onClose();
    }

    getSelectedCount() {
        return this.filterValues.filter((value) => { return value.selected === true }).length
    }

    // Checkbox manipulation

    onSelectAll() {
        var filtered = this.$filter('filter')(this.filterValues, this.$scope.searchText);
        this.filterValues.map((value) => {
            if (filtered.indexOf(value) !== -1) {
                value.selected = true;
            }
            return value;
        });
    }

    onDeselectAll() {
        var filtered = this.$filter('filter')(this.filterValues, this.$scope.searchText);

        this.filterValues.map((value) => {
            if (filtered.indexOf(value) !== -1) {
                value.selected = false;
            }
            return value;
        });
    }

    onCheckboxChange(element) {
        var index = this.filterValues.indexOf(element)
        this.filterValues[index].selected = !this.filterValues[index].selected
    }

    //Filter closing functions

    onFilterClose() {
        if (this.onClose) {
            this.onClose();
            this.uniqueValues = [];
            this.filterValues = [];
        }
    }

    // Possible poduct missmatches
    toServerCase(str) {
        str = str.toLowerCase().split(' ');
        if (str[str.length - 1] === '') {
            str.splice(-1, 1)
        }
        str = str.join('_')
        str = str === 'owner' ? 'tenant_name' : str
        str = str === 'job_duration' ? 'duration' : str
        // str = str === 'backup_status' ? 'status' : str
        str = str === 'compliance_status' ? 'compliancy_status' : str
        str = str === 'compliance_reason' ? 'compliancy_reason' : str
        return str;
    }
}

const pivotTagFilterComponent = {
    controller: PivotTagFilterController,
    controllerAs: 'pivotTagCtrl',
    template: template,
    bindings: {
        editTag: '<',
        tags: '<',
        onClose: '&?',
        onFilter: '&?',
        data: '<',
        config: '=',
        tagPosition: '<',
        filteringMode: '<'
    }
};

PivotTagFilterController.$inject = ['$scope', '$filter', 'utilsService', 'config'];

// module.exports = pivotTableComponent;
module.exports = pivotTagFilterComponent;




// WEBPACK FOOTER //
// ./src/shared/ctxPivotTable/ctxPivotTagFilter.component.js